module.exports = __webpack_public_path__ + "img/title_zhTc@3x.429eb253.png";